import "./video.css"
//@ts-ignore
import noVideo from "../../../../../assets-new/images/noVideo.png"
import { _ } from "i18n"

export function NoVideoMessage() {
    return (
        <div className="noVideoMessage-container">
            <img src={noVideo} alt="noVideoImg" />
            <div className="noVideoMessage-headline">{_("game.noVideo.headline")}</div>
            <div className="noVideoMessage-text">{_("game.noVideo.message")}</div>
        </div>
    )
}